import { TourGuideClient } from '@/lib/tourguide/Tour'

function tourInstance({ tours, ...options }) {
  const mappedSteps = tours.reduce((acc, { steps }) => [...acc, ...steps], [])

  const tg = new TourGuideClient({
    ...options,
    steps: mappedSteps,
  })

  return tg
}

export { tourInstance }
